"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM6 3.99829C6.27614 3.99829 6.5 4.22215 6.5 4.49829V11.5018C6.5 11.7779 6.27614 12.0018 6 12.0018C5.72386 12.0018 5.5 11.7779 5.5 11.5018V4.49829C5.5 4.22215 5.72386 3.99829 6 3.99829ZM10 3.99829C10.2761 3.99829 10.5 4.22215 10.5 4.49829V11.5018C10.5 11.7779 10.2761 12.0018 10 12.0018C9.72386 12.0018 9.5 11.7779 9.5 11.5018V4.49829C9.5 4.22215 9.72386 3.99829 10 3.99829Z"
}));

exports["default"] = _default;